import Teacher from '../../../features/customer/teacher/Teacher';
import values from '../../../features/customer/teacher/configs/values';

const PromotionTeacherPage = ({ history }) => {
  return (
    <>
      <Teacher history={history} type={values.TEACHER_TYPE.promotionTeacher} />
    </>
  );
};

export default PromotionTeacherPage;
